import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useEventList(eventType) {
    const { t } = useI18nUtils()
    const tableColumns = [
        { key: '', label: '', sortable: false },
        { key: 'path', label: t('cover_image'), sortable: false, tdClass:'width-200 p-1' },
        { key: 'title', label: 'Event Name', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false },
    ]
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const eventData = ref(null)
    const events = ref([])
    const totalEvents = ref(0)
    const type = ref('')
    const isEventFormSidebarActive = ref(false)
    const refEventListTable = ref(null)
    const perPage = ref(10)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const statusFilter = ref(null)
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const toast = useToast()
    const dataMeta = computed(() => {
        const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
        const to = Math.min(
            totalEvents.value,
            perPage.value * currentPage.value
        );
        return {
            from,
            to,
            of: totalEvents.value,
        }
    })

    const getType = (eventType) => {
        type.value = eventType
    }

    getType(eventType)

    const refetchData = () => {
        fetchData();
    }

    watch([currentPage, perPage, searchQuery, statusFilter, type], () => {
        refetchData()
    })

    const fetchData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);

        store
            .dispatch('app-event/getEvents', {
                limit: perPage.value,
                offset: offset,
                keywords: searchQuery.value,
                order_by: 'ordering_count DESC',
                sites_id: getLocalSite.id,
                event_type: type.value
            })
            .then(response => {
                events.value = response.data.data
                totalEvents.value = response.data.total
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: "Error fetching Icon' list",
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    const resolveEventStatusVariant = status => {
        if (status ) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolveEventStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const updateEvent = (data) => {
        eventData.value = data
        isEventFormSidebarActive.value = true
    }

    const deleteData = (id) => {
        store.dispatch('app-event/deleteEvent',id).then(response=>{
            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })

            fetchData();
        }).catch((error)=>{
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error Delete Food Category",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    const updateEventOrdering = () => {
        const filteredData = events.value?.filter(item => item !== undefined);
        store.dispatch('app-event/updateOrderingEvents', filteredData)
    }

    return {
        tableColumns,
        refetchData,
        searchQuery,
        fetchData,
        sortBy,
        isSortDirDesc,
        dataMeta,
        refEventListTable,
        currentPage,
        statusFilter,
        perPage,
        perPageOptions,
        resolveEventStatusVariant,
        resolveEventStatusnameVariant,
        updateEvent,
        isEventFormSidebarActive,
        deleteData,
        type,
        events,
        totalEvents,
        getType,
        eventData,
        t,
        updateEventOrdering,
    }
}